<template>
  <div id="BidApply">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <!-- <h3>用章审核</h3> -->
    <div class="contain">
      <el-form :model="form" label-width="200px" :rules="rules" ref="ruleForm">
        <!-- <el-form-item label="申请人" prop="applicant">
          <el-select v-model="form.applicant" placeholder="请选择" class="input">
            <el-option v-for="item in approve" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="招标人" prop="tenderee">
          <el-input
            class="input"
            v-model="form.tenderee"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="采购文件名称" prop="procurefile">
          <el-input
            class="input"
            v-model="form.procurefile"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布途径" prop="publishway">
          <el-input
            class="input"
            v-model="form.publishway"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="publishDate">
          <div
            class="date_box"
            @mouseover="onMouseOver()"
            @mouseleave="onMouseleave()"
          >
            <el-date-picker
              style="width: 100%"
              v-model="form.publishDate"
              type="date"
              placeholder="请选择日期"
            >
            </el-date-picker>
            <i class="el-icon-date" ref="iconDate"></i>
          </div>
        </el-form-item>

        <el-form-item label="方式" prop="way">
          <el-input
            class="input"
            v-model="form.way"
            placeholder="请输入"
          ></el-input>
          <!-- <el-select v-model="form.way" placeholder="请选择" class="input">
            <el-option v-for="item in method" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="类型" prop="tenderType">
          <el-input
            class="input"
            v-model="form.tenderType"
            placeholder="请输入"
          ></el-input>
          <!-- <el-select v-model="form.TenderType" placeholder="请选择" class="input">
            <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="采购内容" prop="procurecontent">
          <el-input
            class="input"
            v-model="form.procurecontent"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请人" prop="applicant">
          <el-select
            v-model="form.applicant"
            clearable
            placeholder="请选择"
            filterable
            class="input"
            @change="selectChange()"
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拟组建的法律服务团队成员" prop="lawTerm">
          <el-select
            clearable
            v-model="form.lawTerm"
            placeholder="请选择"
            class="input"
            multiple
            filterable
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请事项" prop="matter">
          <el-input
            class="input"
            v-model="form.matter"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="申请理由" prop="reason">
          <el-input
            class="input"
            v-model="form.reason"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="投标决策委员会审核意见" prop="opinion">
          <!-- <el-input v-model="form.cuase" class="input" placeholder="请输入"></el-input> -->
          <el-input
            class="input"
            v-model="form.opinion"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="投标决策委员会成员" prop="bidDecisionTeam">
          <el-select
            v-model="form.bidDecisionTeam"
            placeholder="请选择"
            class="input"
            multiple
            filterable
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select v-model="form.sealtype" placeholder="请选择" class="input">
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门审批人" prop="departmentLeaders">
          <el-select
            class="input"
            v-model="form.departmentLeaders"
            placeholder="请先选择申请人"
            filterable
          >
            <el-option
              v-for="item in depLeaders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次审批人" prop="applicantS">
          <el-select
            v-model="form.applicantS"
            placeholder="请选择"
            class="input"
            filterable
          >
            <el-option
              v-for="item in tenderapprove"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件" prop="file" ref="fileupload">
          <el-upload
            class="upload_file"
            v-model="form.file"
            drag
            action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=投标审批"
            multiple
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :file-list="FileList"
            :on-success="uploadSuccess"
            :on-change="onChange"
            :show-file-list="false"
            :on-progress="onProgress"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              最大可上传50M,jpg,jpeg,png,doc,docx,xls,xlsx类型可上传
            </div>
          </el-upload>
          <!-- 附件回显 -->
          <div
            v-for="(item, index) in FileList"
            :key="item.uid"
            class="file_show"
            style="margin-top: 10px"
          >
            <div class="fj" v-if="!item.isShow">
              <div style="flex: 1">
                <img
                  src="../../assets/file/word.svg"
                  v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                />
                <img
                  src="../../assets/file/xls.svg"
                  v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                />
                <img
                  src="../../assets/file/png.svg"
                  v-if="
                    item.ftype == 'jpg' ||
                    item.ftype == 'jpeg' ||
                    item.ftype == 'png'
                  "
                />
                <img
                  src="../../assets/file/PDF.svg"
                  v-if="item.ftype == 'pdf'"
                />
              </div>
              <div class="name" style="flex: 9">
                <div class="fname">
                  {{ item.name }}
                </div>
                <div class="word">
                  <span @click="look(item)" class="look">预览</span>
                  <!-- <span class="down" @click="down(item)">下载</span> -->
                  <span @click="del(index)" class="del">删除</span>
                </div>
              </div>
            </div>
            <!--文件上传进度条-->
            <div class="uploadprocess" v-else>
              <div>
                <div class="jdtext">
                  <div class="uploadname">{{ item.name }}</div>
                  <div class="per">{{ item.curPercentage }}%</div>
                </div>
                <el-progress
                  :percentage="item.curPercentage"
                  :show-text="false"
                ></el-progress>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" @click="Post('ruleForm')">提交</el-button>
        <el-button class="history" @click="history">返回</el-button>
      </div>
    </div>
    <el-dialog
      title="用章申请"
      center
      :visible.sync="applyDialog"
      width="40%"
      @close="closedialog"
    >
      <el-form
        class="form"
        label-width="120px"
        :model="dialogform"
        :rules="ruleseal"
        ref="ruleformseal"
      >
        <el-form-item label="申请人" prop="applicant">
          <el-select
            v-model="dialogform.applicant"
            placeholder="请选择"
            style="width: 50%"
            filterable
            @change="sealChange()"
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select
            v-model="dialogform.sealtype"
            placeholder="请选择"
            style="width: 50%"
            disabled
          >
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门审批人" prop="SealLeaders">
          <el-select
            v-model="dialogform.SealLeaders"
            placeholder="请先选择申请人"
            style="width: 50%"
            clearable
            filterable
          >
            <el-option
              v-for="item in SealdepLeaders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次审批人" prop="approver">
          <el-select
            v-model="dialogform.approver"
            placeholder="请选择"
            style="width: 50%"
            clearable
          >
            <el-option
              v-for="item in Sealapprove"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章事由" prop="reason">
          <el-input
            placeholder="请输入"
            v-model="dialogform.reason"
            type="text"
            style="width: 50%"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="sealfile">
          <el-select
            v-model="dialogform.sealfile"
            placeholder="请选择"
            style="width: 50%"
            multiple
            filterable
            onchange
          >
            <el-option
              v-for="(item, index) in FileList"
              :key="index"
              :label="item.name"
              :value="item.uid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="addEnter('ruleformseal')" type="primary"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { TenderApply } from '../../api/tender'
import { user } from '../../api/seal'
import { GetDepartmentLeaders } from '../../api/bankrupt'
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import mammoth from 'mammoth'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'BidApply',
  data() {
    return {
      isLoading: false,
      active: 'BidApply',
      next: true, //是否是三级菜单
      form: {
        tenderee: '',
        procurefile: '',
        publishway: '',
        publishDate: null,
        way: '',
        tenderType: '',
        procurecontent: '',
        applicant: '',
        lawTerm: [],
        matter: '',
        reason: '',
        opinion: '',
        bidDecisionTeam: [],
        sealtype: '',
        applicantS: '',
        file: [],
        departmentLeaders: '' //部门审批人
      },
      dialogform: {
        //用章
        applicant: '',
        approver: '',
        sealfile: [],
        reason: '投标申请',
        sealtype: '',
        SealLeaders: ''
      },
      applyDialog: false,
      Lawyer: [], //律师
      SealdepLeaders: [], //用章申请部门领导人
      depLeaders: [], //部门领导人
      ruleseal: {
        applicant: { required: true, message: '不能为空 ', trigger: 'change' },
        approver: { required: true, message: '不能为空 ', trigger: 'change' },
        sealtype: { required: true, message: '不能为空 ', trigger: 'change' },
        reason: { required: true, message: '不能为空 ', trigger: 'change' },
        sealfile: { required: true, message: '不能为空 ', trigger: 'change' },
        SealLeaders: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      rules: {
        tenderee: { required: true, message: '不能为空', trigger: 'change' },
        lawTerm: { required: true, message: '不能为空', trigger: 'change' },
        applicant: { required: true, message: '不能为空', trigger: 'change' },
        sealtype: {
          required: true,
          message: '请选择用章类型',
          trigger: 'change'
        },
        applicantS: {
          required: true,
          message: '请选择二次审批人',
          trigger: 'change'
        },
        bidDecisionTeam: {
          required: true,
          message: '不能为空',
          trigger: 'change'
        },
        file: { required: true, message: '不能为空 ', trigger: 'change' },
        departmentLeaders: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        }
      },
      method: [], //方式
      type: [], //类型
      Sealapprove: [],
      tenderapprove: [], //申请人
      apptype: 'Tender',
      Term: [], //法律团队成员
      FileList: [], //用章附件
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' }
        // { label:"律师函专用章",value:"legal_letter_seal"},
      ], //用章类型

      // 文件预览
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1 //回退次数
    }
  },

  methods: {
    GetUser() {
      user({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data.filter((item) => item.status == 0||item.status==6)
          if (this.Lawyer.length > 0) {
            this.form.applicant = this.Lawyer[0].uid
            this.dialogform.applicant = this.Lawyer[0].uid
            this.selectChange()
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    closedialog() {
      this.apptype = 'Tender'
    },
    GetDepartmentLeaders(id) {
      //获取部门审批人
      GetDepartmentLeaders({ Id: id }).then((res) => {
        if (res.data.status == 0) {
          if (this.apptype == this.form.sealtype) {
            //用章的部门审批人
            this.SealdepLeaders = res.data.data
            var index = this.SealdepLeaders.findIndex((item) => {
              return item.value == this.dialogform.SealLeaders
            })
            if (index == -1) {
              //不存在，清空
              this.dialogform.SealLeaders = ''
            }
          }
          if (this.apptype == 'Tender') {
            //案件的部门审批人
            this.depLeaders = res.data.data
            var index = this.depLeaders.findIndex((item) => {
              return item.value == this.form.departmentLeaders
            })
            // console.log("index:" + index)
            if (index == -1) {
              //不存在，清空
              this.form.departmentLeaders = ''
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          if (this.apptype == this.form.sealtype) {
            //用章的部门审批人
            this.SealdepLeaders = []
            this.dialogform.SealLeaders = ''
          }
          if (this.apptype == 'Tender') {
            this.depLeaders = []
            this.form.departmentLeaders = ''
          }
          this.$message.error(res.data.message)
        }
      })
    },
    GetApprove() {
      //获取二次审批人
      user({ Id: this.form.applicant, apporver: this.apptype }).then((res) => {
        if (res.data.status == 'success') {
          if (this.apptype == this.form.sealtype) {
            this.Sealapprove = res.data.data
            var index = this.Sealapprove.findIndex((item) => {
              return item.id == this.dialogform.approver
            })
            if (index == -1) {
              //不存在，清空二次审批人
              this.dialogform.approver = ''
            }
          } else {
            this.tenderapprove = res.data.data
            var index = this.tenderapprove.findIndex((item) => {
              return item.id == this.form.applicantS
            })
            if (index == -1) {
              //不存在，清空二次审批人
              this.form.applicantS = ''
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    selectChange() {
      this.GetApprove()
      this.GetDepartmentLeaders(this.form.applicant)
    },
    sealChange() {
      this.GetApprove()
      this.GetDepartmentLeaders(this.dialogform.applicant)
    },
    //发布日期
    onMouseOver() {
      if (this.form.publishTime != undefined && this.form.publishTime != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.uid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.uid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.uid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },
    del(index) {
      this.FileList.splice(index, 1)
      this.dialogform.sealfile = []
    },
    Post(form) {
      this.form.file = this.FileList.map((v) => {
        return v.uid
      })
      this.$refs[form].validate((success) => {
        if (success) {
          this.dialogform.sealtype = this.form.sealtype
          this.applyDialog = true
          this.apptype = this.dialogform.sealtype
          this.sealChange()
          // this.dialogform.applicant = this.form.applicant
        } else {
          this.$message.error('有必填项为空')
        }
      })
    },
    addEnter(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          if (this.form.publishDate) {
            this.form.publishDate = this.JsonTime(this.form.publishDate) //时间格式转换
          }
          // console.log(this.form.publishDate)
          TenderApply({
            FileList: this.form.file,
            Tenderee: this.form.tenderee,
            ProcureFile: this.form.procurefile,
            ApplicantId: this.form.applicant,
            PublishWay: this.form.publishway,
            PublishDate: this.form.publishDate,
            Way: this.form.way,
            TenderType: this.form.tenderType,
            ProcureContent: this.form.procurecontent,
            LegalTeam: this.form.lawTerm,
            Matter: this.form.matter,
            Reason: this.form.reason,
            Opinion: this.form.opinion,
            BidDecisionTeam: this.form.bidDecisionTeam,
            SealType: this.form.sealtype,
            SealReason: this.dialogform.reason,
            SealApplicantId: this.dialogform.applicant,
            Seallist: this.dialogform.sealfile,
            Approver: this.form.applicantS,
            SealApprover: this.dialogform.approver,
            DepartmentLeaders: this.form.departmentLeaders,
            SealLeaders: this.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('投标申请成功，请等待审核!')
              this.$router.push({
                path: `/home/seal/Bidrecord`
              })
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        }
      })
    },
    handleRemove(file, fileList) {
      //删除附件
      this.FileList.forEach((value, index, array) => {
        //删除上传失败的文件
        // console.log(file.uid)
        if (value.uid == file.uid) {
          array.splice(index, 1)
        }
      })
    },
    handlePreview(file) {
      // console.log(file);
    },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    onProgress(event, file) {
      let num = ((event.loaded / event.total) * 100) | 0 //百分比
      this.FileList.forEach((value) => {
        //uid要改成guid,isshow变成false
        if (value.uid == file.uid) {
          value.curPercentage = num
        }
      })
    },

    onChange(file) {
      if (file.status == 'fail') {
        this.FileList.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
        return this.$message.error(file.name + '上传失败')
      }
    },
    // beforeRemove(file, fileList) {//删除触发
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    beforeUpload(file, filelist) {
      var type = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
      this.FileList.push({
        uid: file.uid,
        name: filename,
        ftype: type,
        isShow: true,
        curPercentage: 0
      }) //添加上传的文件

      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.wps,.WPS'.indexOf(type) >=
        0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList) {
      //上传成功
      // console.log(file)
      if (res.status == '0') {
        // this.$refs.fileupload.clearValidate()
        this.FileList.forEach((value) => {
          //uid要改成guid,isshow变成false
          if (value.uid == file.uid) {
            value.isShow = false
            value.uid = file.response.data.substring(
              file.response.data.lastIndexOf('=') + 1
            )
          }
        })
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
    },

    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    }
  },
  created() {
    this.getvalue()
    this.GetUser()
    // this.GetApprove()
  },
  computed: {}
}
</script>
  
<style lang="less" scoped>
// 日历
::v-deep .el-input__prefix {
  display: none;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

#BidApply .date_box {
  width: 50%;

  .el-icon-date {
    position: absolute;
    top: 50%;
    right: calc(50% + 10px);
    z-index: 9;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }
}

#BidApply .contain {
  width: 60%;
  margin: auto;
}

#BidApply .input {
  width: 50%;
}

#BidApply .fj {
  display: inline-flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
}

#BidApply img {
  width: 100%;
  height: 100%;
}

#BidApply .fname {
  display: inline-flex;
  flex-direction: column;
  // padding-left: 10px;
}

#BidApply /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#BidApply .footer {
  margin-left: 200px;
}

#BidApply .history {
  border: 1px solid #2bc887;
  color: #2bc887;
}

// 附件回显
#BidApply .upload_file {
  width: 360px;
}

#BidApply .file_show {
  width: 360px;
}

#BidApply .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#BidApply img {
  width: 100%;
  height: 100%;
}

#BidApply .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#BidApply .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#BidApply .word {
  line-height: 24px;
  cursor: default;
}

#BidApply /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#BidApply .look {
  color: #fe964a;
  margin-right: 10px;
}

#BidApply .down {
  color: #2bc887;
  margin-right: 10px;
}

#BidApply .del {
  color: hsl(356, 93%, 50%);
}

//进度条
#BidApply .uploadprocess {
  width: 360px;
}

#BidApply .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#BidApply .jdtext {
  width: 360px;
  display: flex;
}

#BidApply .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}
</style>
  